<template>
    <footer class="footer custom-footer">
        <div class="row">
            <div class="col text-right">
                <template v-for="(item, index) in footerMenuItems">
                    <a
                        :key="item.id"
                       :id="'foot' + item.name.toLowerCase().replace(/\s+/g, '') + 'btn'"
                       :tabindex="301 + index"
                       :target="item.target === 'New Window' ? '_blank' : ''"
                       :title="item.name"
                       :href="item.url"
                    >{{ item.name }}</a>
                </template>
                <span>{{ rights() }}</span>
            </div>
        </div>
    </footer>
</template>

<script>
import {mapState} from 'vuex';

export default {
    name: 'FooterComponent',
    props: {
        menu: {
            type: Object,
        }
    },
    computed: {
        ...mapState({
            user: state => state.user.user,
        }),
        footerMenuItems() {
            if (this.user) return this.user.menus?.find(menu => menu.name === 'Footer Menu')?.items || []
            else if (this.menu) return this.menu?.original?.items?.filter((item) => !item.healthplan_details.length) || [];
        },
        currentYear() {
            return new Date().getFullYear();
        }
    },
    methods: {
        checkIsMobile() {
            return this.isMobile = window.innerWidth <= 992;
        },
        rights() {
            return (this.checkIsMobile() ? '' : '© ') + 'Compass Rose Benefits Group. All Rights Reserved.'
        },
    }
}
</script>

<style scoped>

</style>
